import { createStore } from 'framework7';
import { http } from '../api/config.js';

const place = createStore({
  state: {
    item: {},
    list: [],
  },
  actions: {
//Mutations
    set_item({ state }, item) {
      state.item = item;
    },
//End mutations
    async getCountryProvinces({ dispatch }){
      let response = [];
      let result = {};

      //
      result = await http.get(`places/country/provinces/7`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },
    async getProvincePlaces({ dispatch }, provinceId){
      let response = [];
      let result = {};

      result = await http.get(`place/country/province/locations/${provinceId}`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },
    async getLocalitiesList({ dispatch }, queryString){
      let response = [];
      let result = {};

      result = await http.get(`place/localities/list?${queryString}`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },

  },
  getters: {
    Item({ state }) {
      return state.item;
    }
  },
});

export default place;
